import { gql } from '@apollo/client';
import { getShortTextLabelsQueryString } from './utils';

export const getUuidSentCollection = gql`
	query getVignettesOrderManagementCollection($lang: String) {
		vignettesOrderManagementCollection(locale: $lang, limit: 1) {
			items {
				uuidSentText(locale: $lang) {
					json
				}
				${getShortTextLabelsQueryString(['uuidSentHeadline', 'uuidSentText', 'uuidSentMissingEmail', 'tryAgainText'])}
			}
		}
	}
`;
